<template>
  <div>
    <div class="pt-2 pl-2">
      <div class="input-group" v-for="staff in inputs.staffs" :key="staff.id">
        <p class="pr-2">
          <a href="#" @click.prevent="remove(staff.id)" :class="{disabled:disabled}">Ｘ</a>
        </p>
        <p>
          {{staff.display_name}}
        </p>
      </div>
      <div v-if="inputs.staffs.length === 0">
        <p>スタッフを選択してください。</p>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'StaffCheckBoxList',
  props: ['value', 'disabled'],
  data () {
    return {
      inputs: { staffs: [] }
    }
  },
  watch: {
    value: function () {
      this.inputs.staffs = this.value ? this.value : []
      this.inputs.staffs = _.sortBy(this.inputs.staffs, ['display_name_kana', 'display_name'])
    }
  },
  created: function () {
    this.inputs.staffs = this.value ? this.value : []
    this.inputs.staffs = _.sortBy(this.inputs.staffs, ['display_name_kana', 'display_name'])
  },
  methods: {
    remove (staffId) {
      if (this.disabled) return
      const index = _.findIndex(this.inputs.staffs, staff => {
        return staff.id === staffId
      })
      if (index < 0) return
      this.inputs.staffs.splice(index, 1)
      this.inputs.staffs = _.sortBy(this.inputs.staffs, ['display_name_kana', 'display_name'])
      this.$emit('input', this.inputs.staffs)
      this.$emit('change', this.inputs.staffs)
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  cursor: not-allowed;
  color: gray
}
</style>
